import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vnd',
  templateUrl: './vnd.component.html',
  styleUrls: ['./vnd.component.scss']
})
export class VndComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
